import { Component } from '@angular/core';

@Component({
  selector: 'not-authorized',
  template: ` <h3 class="alert">You are not authorized to view this page</h3> `,
})
export class NotAuthorizedComponent {}
